class LoadMore {
  constructor() {
    this.$body = $('body')
    this.scopeRole = {
      loadMore: '[data-role="load-more"]',
    }
    this.ajaxMethod = {
      putAction: 'query_get',
    }

    if(this.$body.find(this.scopeRole.loadMore).length) {
      this.init()
    }
  }

  init() {
    this.$body.find(this.scopeRole.loadMore).on('click', (evt) => {
      evt.preventDefault()
      const $el = $(evt.currentTarget)
      const data = {
        action: this.ajaxMethod.putAction,
        // eslint-disable-next-line no-undef
        security: ajax_object.ajax_nonce,
        posts_per_page: $el.data('posts-per-page'),
        post_type: $el.data('post-type'),
        paged: $el.data('paged'),
        term: $el.data('term'),
      }
      this.ajaxRequest(data, $el)
    })
  }

  ajaxRequest(data, $el) {
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_object.ajax_url,
      method: 'POST',
      data: data,
    }).done((response) => {
      const data = JSON.parse(response)
      this.$body.find(`${$el.data('target')}`).append(data.template)
      if (parseInt(data.current_page) <= parseInt($el.data('max'))) {
        $el.remove()
      }
    })
  }
}

export default LoadMore;



// WEBPACK FOOTER //
// ./scripts/components/LoadMore.js